import ReactGA from "react-ga";

const AnalyticsEventTracker = (category="DriverLicense") => {
  const eventTracker = (action = "test action", label = "test label") => {
    ReactGA.event({category, action, label});
  }
  return eventTracker;
}
export default AnalyticsEventTracker;
